import { colors } from '../../colors';
var threeTile = {
  borderColor: colors.overcast,
  headingColor: colors.onyx,
  paraColor: colors.onyx,
  subHeadingColor: colors.onyx,
  bgColor: colors.whiteish,
  ctaColor: colors.azure,
  textColorDark: colors.onyx,
  textColorLight: colors.white,
  cardBgColorVariationC: colors.white
};
export default threeTile;